


































































import { Component, Prop } from 'vue-property-decorator';
import { DepositAccountModule } from '@/store/Accounts/DepositAccountModule';
import { DepositAccountSettingsModule } from '@/store/Accounts/DepositAccountSettingsModule';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import DepositAccount from '@/models/Accounts/DepositAccounts/DepositAccount';
import Details from '@/components/Accounts/DepositAccounts/Details/Details.vue';
import WalletSelectorToolbar from '@/components/Accounts/DepositAccounts/Wallets/WalletSelectorToolbar.vue';
import PaymentOrders from '@/components/Accounts/Shared/PaymentOrders/PaymentOrders.vue';
import Payments from '@/components/Accounts/Shared/Payments/Payments.vue';
import Payees from '@/components/Accounts/Shared/Payees/Payees.vue';
import Mandates from '@/components/Accounts/DepositAccounts/Mandates/Mandates.vue';
import Fees from '@/components/Accounts/Shared/Fees/Fees.vue';
import FeesUnavailableOnAccount from '@/components/Accounts/Shared/Fees/FeesUnavailableOnAccount.vue';
import HistorySubTabs from '@/components/Accounts/Shared/History/HistorySubTabs.vue';
import History from '@/components/Shared/History.vue';
import EntityType from '@/models/Shared/EntityType';
import PermissionUtils from '@/lib/permissionUtils';
import FeatureToggleCode from "@/models/Settings/Institutions/FeatureToggleCode";
import ProductSubType from '@/models/Products/ProductSubType';

@Component({ name: 'DepositNoticeAccountTabs', components: { Details, WalletSelectorToolbar, PaymentOrders, Payments, Payees, Mandates, Fees, FeesUnavailableOnAccount, HistorySubTabs, History } })
export default class extends SaascadaVue {

    @Prop({ required: true })
    account: DepositAccount;

    EntityType = EntityType;
    PermissionUtils = PermissionUtils;
    FeatureToggleCode = FeatureToggleCode;
    ProductSubType = ProductSubType;

    tabIndex = 0;

    async created() {
        // Check for tab index number in URL parameters
        const tab = this.$route.query.tab;
        if (tab) {
            this.tabIndex = +tab;
        }
        else {
            this.$router.push({ name: this.$route.name, params: { id: this.$route.params.id }, query: { tab: `0` } });
        }
    }

    get allowFees(){
        // Allow fees if at least one of the template options is available
        let templatedFeesAvailable = true;
        if (PermissionUtils.isFeatureToggleEnabled(FeatureToggleCode.ProductFees)) {
            templatedFeesAvailable = DepositAccountSettingsModule.productIssue.generalFeeSettings?.arbitraryFeesEnabled;
        }
        let manualFeesAvailable = false;
        if (PermissionUtils.isFeatureToggleEnabled(FeatureToggleCode.AdHocFees)) {
            manualFeesAvailable = !!DepositAccountSettingsModule.productIssue.generalFeeSettings?.manualFees;
        }
        return templatedFeesAvailable || manualFeesAvailable;
    }

    get defaultWalletCurrency() {
        // Use this method to get the currency because it works in both UX and FI APIs
        const defaultWallet = DepositAccountModule.depositAccount.wallets.find(wallet => wallet.default);
        return defaultWallet.currency;
    }

    async changeTab() {
        // Update route with tab number
        this.$router.push({ name: this.$route.name, params: { id: this.$route.params.id }, query: { tab: `${this.tabIndex}` } });
    }

}
